import type { CSSProperties } from 'react'

import { contrastRatio } from './contrast.ts'

export type BrandVariables = CSSProperties & Partial<Record<'--brand' | '--primary' | '--primary-foreground' | '--primary-hover' | '--ring', string>>

/** Black text needs at least 4.5:1 on the fill (WCAG 1.4.3). */
const BLACK_TEXT_MINIMUM = 4.5

export function brandVariables(brand: string): BrandVariables {
  if (contrastRatio(brand, '#000000') < BLACK_TEXT_MINIMUM) return { '--brand': brand }
  return {
    '--brand': brand,
    '--primary': brand,
    '--primary-foreground': '#000000',
    // Lightening raises the contrast against black text, so hover never drops below AA.
    '--primary-hover': `color-mix(in oklab, ${brand} 82%, white)`,
    '--ring': brand,
  }
}

